import { MyContext } from 'contexts/Context';
import React, { createContext, useState, useContext } from 'react';



export interface AccountProfile {
  id: number;
  firstName: string;
  email: string;
  phoneNumber: string;
}

export const isSuccess = (
  output: any
) => {
  // console.log(output)
  const payload = output;
  return payload && payload['result'] && payload['result']['flag']  === 1;
  // return payload
  
};


export const successData = (
  output: any
) => {
  const payload = output;
  // console.log(payload,"payload")
  // return payload && payload['result'] && payload['result']['data'] && payload['result']['data'];

  // return payload && payload['data'] && payload['data']['users_detail']&& payload['data']['tokens'];
  return payload && payload['data'];
  // return payload && payload['body'] && payload['body']['data'] && payload['body']['data'];
  
};
export const errorMessage = (
  output: any
) => {
  const payload = output ? JSON.parse(output) : null;
  return payload && payload['errors'] && payload['errors']['ucc_pan'] && payload['errors']['ucc_pan'] ? payload['errors']['ucc_pan'] : "";
};
